// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"9c9b24ba","174":"8d43ac67","845":"0fff54ff"}[chunkId] + ".chunk.js";
};